/* script */






































































import { computed, defineComponent, PropType, reactive } from '@vue/composition-api'
import Loading from '../components/Loading.vue'
import { uniqueId } from 'lodash-es'

type IndustrySmallSector = { id: number; name: string }
type IndustryMiddleSector = { id: number; name: string; industry_small_sectors: IndustrySmallSector[] }
type IndustrySector = { id: number; name: string; industry_middle_sectors: IndustryMiddleSector[] }

const __vue_script__ = defineComponent({
  components: { Loading },
  props: {
    initialSelectedIndustrySmallSectorIds: {
      type: Array as PropType<number[]>,
      default: (): [] => [],
    },
    name: {
      type: String,
      default: '',
      required: false,
    },
  },
  setup: (props, context) => {
    const state = reactive({
      sectors: [] as IndustrySector[],
      selectedSectorId: 0,
      selectedSmallSectorIds: props.initialSelectedIndustrySmallSectorIds.map((id) => Number(id)) || [],
    })

    const sectorOptions = computed(() => [
      { id: 0, name: '業界分類を選択してください', industry_middle_sectors: [] },
      ...state.sectors,
    ])

    const setupSectors = async (): Promise<void> => {
      const response = await fetch('/industry_sectors.json')
      state.sectors = await response.json()
    }

    setupSectors()

    const allSmallSectors = computed<IndustrySmallSector[]>(() =>
      state.sectors
        .flatMap((sector) => sector.industry_middle_sectors)
        .flatMap((middle) => middle.industry_small_sectors),
    )
    const selectedSmallSectors = computed(() =>
      allSmallSectors.value.filter(({ id }) => state.selectedSmallSectorIds.includes(id)),
    )
    const modalId = computed(() => uniqueId('industry-small-sector-selection-'))
    const smallSectorOptionId = (small: IndustrySmallSector): string => {
      return `modal-${modalId.value}-industry-small-sector-${small.id}`
    }
    const unselectSmallSector = (unselectedId: number): void => {
      state.selectedSmallSectorIds = state.selectedSmallSectorIds.filter((id) => id !== unselectedId)
      context.emit('change:industry-small-sectors', state.selectedSmallSectorIds)
      context.emit('input', state.selectedSmallSectorIds)
    }
    const onSmallSectorChanged = (): void => {
      context.emit('change:industry-small-sectors', state.selectedSmallSectorIds)
      context.emit('input', state.selectedSmallSectorIds)
    }

    return {
      props,
      state,
      sectorOptions,
      selectedSmallSectors,
      smallSectorOptionId,
      unselectSmallSector,
      onSmallSectorChanged,
    }
  },
})

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { label: "業界分類" } },
      [
        _c("b-form-select", {
          staticClass: "mb-2",
          attrs: {
            id: "industry-small-sector-selection-form-select-input",
            options: _vm.sectorOptions,
            "value-field": "id",
            "text-field": "name",
          },
          model: {
            value: _vm.state.selectedSectorId,
            callback: function ($$v) {
              _vm.$set(_vm.state, "selectedSectorId", $$v)
            },
            expression: "state.selectedSectorId",
          },
        }),
        _vm._v(" "),
        _vm._l(_vm.state.sectors, function (sector) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state.selectedSectorId === sector.id,
                  expression: "state.selectedSectorId === sector.id",
                },
              ],
              key: sector.id,
            },
            [
              _c(
                "b-card",
                _vm._l(sector.industry_middle_sectors, function (middle) {
                  return _c(
                    "div",
                    { key: middle.id, staticClass: "mb-3" },
                    [
                      _c("strong", [_vm._v(_vm._s(middle.name))]),
                      _vm._v(" "),
                      _vm._l(middle.industry_small_sectors, function (small) {
                        return _c(
                          "div",
                          {
                            key: small.id,
                            staticClass: "custom-control custom-checkbox",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.state.selectedSmallSectorIds,
                                  expression: "state.selectedSmallSectorIds",
                                },
                              ],
                              staticClass:
                                "custom-control-input js-industry-small-sector-modal-checkbox",
                              attrs: {
                                id: _vm.smallSectorOptionId(small),
                                type: "checkbox",
                                name: _vm.props.name,
                              },
                              domProps: {
                                value: small.id,
                                checked: Array.isArray(
                                  _vm.state.selectedSmallSectorIds
                                )
                                  ? _vm._i(
                                      _vm.state.selectedSmallSectorIds,
                                      small.id
                                    ) > -1
                                  : _vm.state.selectedSmallSectorIds,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.state.selectedSmallSectorIds,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = small.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.state,
                                            "selectedSmallSectorIds",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.state,
                                            "selectedSmallSectorIds",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.state,
                                        "selectedSmallSectorIds",
                                        $$c
                                      )
                                    }
                                  },
                                  _vm.onSmallSectorChanged,
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: _vm.smallSectorOptionId(small) },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(small.name) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.sectorOptions.length === 1
          ? _c("div", [_c("Loading")], 1)
          : _vm.selectedSmallSectors.length === 0
          ? _c(
              "b-alert",
              { staticClass: "mt-1", attrs: { show: "", variant: "warning" } },
              [_vm._v("\n      業界は未選択です\n    ")]
            )
          : _c(
              "b-card",
              { staticClass: "bg-yellow-light mt-1 p-0" },
              [
                _c("strong", [_vm._v("選択中の業界")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._l(_vm.selectedSmallSectors, function (small) {
                  return _c(
                    "b-button",
                    {
                      key: small.id,
                      staticClass: "m-1",
                      attrs: { size: "sm", variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.unselectSmallSector(small.id)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fal fa-times" }),
                      _vm._v("\n        " + _vm._s(small.name) + "\n      "),
                    ]
                  )
                }),
              ],
              2
            ),
      ],
      2
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/src/containers/IndustrySmallSectorSelectionForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__